import { generatedKeys } from '@app/data';
import { queryClient } from '@app/QueryClient';

export type SubscriptionEvent = {
	name: string;
	callback: (data: any) => void;
};

export const EVENT_HANDLERS: SubscriptionEvent[] = [
	{
		name: 'subscription.status',
		callback: () => {
			queryClient.refetchQueries({
				queryKey: generatedKeys.settings.SubscriptionDetails?.({})!,
			});
			queryClient.refetchQueries({
				queryKey: generatedKeys.login?.data?.({})!,
			});
		},
	},
];
